const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Simple Email Address validator
 * @constructor
 */
class EmailValidator {
  /**
   * @param {String}address
   * @returns {Boolean}
   */
  static validate(address) {
    return EMAIL_REGEX.test(address);
  }
}

export default EmailValidator;
